// @flow

import { handleError } from '@tectonics/alert-handler';

import visaImageSrc from './images/visa.svg';
import maestroImageSrc from './images/maestro.svg';
import dinersImageSrc from './images/diners.svg';
import nubankImageSrc from './images/nubank.svg';
import santanderImageSrc from './images/santander.svg';
import bancoDoBrasilImageSrc from './images/banco-do-brasil.svg';
import caixaSrc from './images/caixa.svg';
import bradescoImageSrc from './images/bradesco.svg';
import originalImageSrc from './images/original.svg';
import interImageSrc from './images/inter.svg';
import c6ImageSrc from './images/c6.svg';
import bancoobImageSrc from './images/bancoob.svg';
import panImageSrc from './images/pan.svg';
import sicrediImageSrc from './images/sicredi.svg';
import agibankImageSrc from './images/agibank.svg';
import bmgImageSrc from './images/bmg.svg';
import brbImageSrc from './images/brb.svg';
import itauImageSrc from './images/itau.svg';
import infonetImageSrc from './images/infonet.svg';
import meezaImageSrc from './images/meeza.svg';
import rupayImageSrc from './images/rupay.svg';
import verveImageSrc from './images/verve.svg';

export function getDebitCardBrandImageSrc(cardBrand: string): string {
  switch (cardBrand) {
    case 'visa':
      return visaImageSrc;
    case 'mastercard':
      return maestroImageSrc;
    case 'meeza':
      return meezaImageSrc;
    case 'diners':
      return dinersImageSrc;
    case 'nubank':
      return nubankImageSrc;
    case 'santander':
      return santanderImageSrc;
    case 'bancodobrasil':
      return bancoDoBrasilImageSrc;
    case 'caixa':
      return caixaSrc;
    case 'bradesco':
      return bradescoImageSrc;
    case 'original':
      return originalImageSrc;
    case 'inter':
      return interImageSrc;
    case 'c6':
      return c6ImageSrc;
    case 'bancoob':
      return bancoobImageSrc;
    case 'bancopan':
      return panImageSrc;
    case 'sicredi':
      return sicrediImageSrc;
    case 'agibank':
      return agibankImageSrc;
    case 'bancobmg':
      return bmgImageSrc;
    case 'brb':
      return brbImageSrc;
    case 'itau':
      return itauImageSrc;
    case 'infonet':
      return infonetImageSrc;
    case 'rupay':
      return rupayImageSrc;
    case 'verve':
      return verveImageSrc;

    default: {
      handleError(new Error(`getDebitCardBrandImageSrc - there is no image source for "${cardBrand}"`));
      return '';
    }
  }
}
